<template>
    <div class="center-horizontal">
        <img  src="https://www.edisac.com/images/article_la/adint.png" alt="Image">
    </div>
    <!-- <div class="home-container" v-if="['A','B','N'].find(el=>el==store.state.user.groupe)"></div> -->
    
</template>
<script setup>
import store from '../store'
</script>

<style scoped>
.home-container {
    background-image: url('../assets/home.png');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    width: 100%;
    height: 100vh;
}
.center-horizontal {
   
    justify-content: center; /* centrage horizontal */
         /* centrage vertical */         /* prend toute la hauteur de la fenêtre */
  }
</style>